<template>
  <div>
    <home-hero :stores-url="storesUrl" :guides-url="guidesUrl" />
    <home-how-it-works />
    <home-app-band />
    <section class="home-contact">
      <b-container class="text-center">
        <h2 class="home-contact__heading">{{ $t('pages.home.contact.title', { appName }) }}</h2>
        <p class="home-contact__text">{{ $t('pages.home.contact.text') }}</p>
        <b-button
          variant="outline-primary"
          @click="$bvModal.show('feedback-form')"
        >
          {{ $t('pages.home.card3.button', { appName }) }}
        </b-button>
      </b-container>
    </section>
    <feedback-modal
      modalId="feedback-form"
      @formSubmit="sendFeedback"
    />
  </div>
</template>

<script>

  import FeedbackModal from '@base/components/FeedbackModal.vue'
  import HomeHero from '@anonymous/components/home/HomeHero.vue'
  import HomeHowItWorks from '@anonymous/components/home/HomeHowItWorks.vue'
  import HomeAppBand from '@anonymous/components/home/HomeAppBand.vue'
  import { APP_NAME, MOBILE_APP_HELP_URLS, STORES_DIRECTORY_URL } from "@base/configs";

  export default {
    name: 'Home',

    components: {
      FeedbackModal,
      HomeHero,
      HomeHowItWorks,
      HomeAppBand,
    },

    data () {
      return {
        appName: APP_NAME,
        storesUrl: STORES_DIRECTORY_URL,
      }
    },

    computed: {
      guidesUrl () {
        return MOBILE_APP_HELP_URLS[this.$i18n.locale.toUpperCase()] || MOBILE_APP_HELP_URLS.EN
      },
    },

    methods: {
      sendFeedback (payloads) {
        this.loader = this.$loading.show(this.$_loaderOptions)
        this.$store.dispatch(this.$_actionTypes.SEND_FEEDBACK, payloads)
          .then(() => {
            this.$nextTick(() => {
              this.$bvModal.hide('feedback-form')
            })
            this.$notify({
              group: 'app',
              type: 'success',
              title: this.$t('notifications.title.success'),
              text: this.$t('notifications.text.feedback.success_feedback_sent')
            })
          })
          .catch((error) => {
            this.$_notifyError(error, this)
          })
          .finally(() => {
            this.loader.hide()
          })
      }
    },
  }
</script>

<style scoped>
  .home-contact {
    padding: 3rem 0 2rem;
  }

  .home-contact__heading {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--ui-ink);
    margin-bottom: 0.5rem;
  }

  .home-contact__text {
    color: var(--ui-muted);
    max-width: 36rem;
    margin: 0 auto 1.25rem;
  }
</style>
